/**
 * Solo music project — smart link page content (/music/links).
 * Edit these values for each release.
 */

export type MusicLinkAction = 'play' | 'go' | 'download';

export interface MusicLink {
  label: string;
  href: string;
  /** Shown on the right side of the button, like link.to */
  action: MusicLinkAction;
}

export type MusicEventAction = 'tickets' | 'rsvp' | 'info';

export interface MusicEvent {
  label: string;
  href: string;
  action: MusicEventAction;
}

export interface MusicLinksRelease {
  title: string;
  subtitle: string;
  /** YouTube video ID (from youtube.com/watch?v=THIS_PART) */
  youtubeVideoId: string;
  /** Optional custom square artwork; falls back to YouTube thumbnail */
  artworkUrl?: string;
  links: MusicLink[];
  events: MusicEvent[];
}

export const musicLinksRelease: MusicLinksRelease = {
  title: 'After Selection EP',
  subtitle: 'Out Now',
  youtubeVideoId: 'RbvE7beHmb0',
  links: [
    { label: 'Bandcamp', href: 'https://christophersamuels.bandcamp.com/album/after-selection', action: 'download' },
    { label: 'YouTube Music', href: 'https://music.youtube.com/playlist?list=OLAK5uy_k0BnbfTkbxcjmFJcv9fL0TleTVW1FlH2Q', action: 'play' },
    { label: 'Spotify', href: 'https://open.spotify.com/artist/61MLi8hyZNxBZ0qsLuiIPK', action: 'play' },
    { label: 'Apple Music', href: 'https://music.apple.com/us/album/after-selection-ep/6769373163', action: 'play' },
    { label: 'Amazon Music', href: 'https://music.amazon.com/albums/B0H1S1F4PX', action: 'play' },
  ],
  events: [
    { label: '11/01 @ Paris Bar, Detroit', href: 'https://ra.co/events/2536039', action: 'tickets' },
  ],
};

export const actionLabels: Record<MusicLinkAction, string> = {
  play: 'Play',
  go: 'Go To',
  download: 'Download',
};

export const eventActionLabels: Record<MusicEventAction, string> = {
  tickets: 'Tickets',
  rsvp: 'RSVP',
  info: 'Info',
};

export function youtubeThumbnail(videoId: string): string {
  return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
}

export function youtubeEmbedUrl(videoId: string, autoplay = true): string {
  const params = new URLSearchParams({
    autoplay: autoplay ? '1' : '0',
    rel: '0',
    modestbranding: '1',
  });
  return `https://www.youtube.com/embed/${videoId}?${params}`;
}
